module.exports = {
  data() {
    return {
      resultsSummary: []
    };
  },

  methods: {
    /*
      Rebuild the search arguments and getPosts
    */
    modifySearch(getposts = false) {
      let modifiedSearch = {};
      let vm = this;

      for (let i = 0; i < vm.resultsSummary.length; i++) {
        let term = vm.resultsSummary[i];
        if (!modifiedSearch[term.type]) {
          modifiedSearch[term.type] = term.slug;
        } else {
          modifiedSearch[term.type] += "," + term.slug;
        }
      }

      if (getposts) {
        vm.getPosts(modifiedSearch);
      }
    },

    /*
      Takes search parameters and returns an array of objects used to display results tags
    */
    buildResultsSummary: function(data) {
      this.resultsSummary = [];

      for (let d in data) {
        let tags = data[d];

        if (typeof tags == "object" && tags.length > 0) {
          for (let i = 0, length = tags.length; i < length; i++) {
            this.resultsSummary.push({
              name: tags[i].name,
              slug: tags[i].slug,
              type: d
            });
          }
        } else if (typeof tags == "string" && tags !== "") {
          this.resultsSummary.push({
            name: tags,
            type: d
          });
        }
      }
    }
  }
};
